import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "context/LanguageContext";
import { useNotification } from "context/NotificationContext";
import {
  renderYesNoField,
  renderRangeField,
  renderInputTextField,
  renderCheckboxGroup,
  convertYesNoFieldsToString,
  validateFields,
  handleConfirmSave,
  handleNavigateBack,
  renderSelectField
} from "components/formUtils";

const CirurgiaForm = () => {
  const { GetTranslation } = useLanguage();
  const notify = useNotification();
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    revascularizacao: null ,
    abordagem_valvar: null ,
    abordagem_aorta: null ,
    correcao_cardiopatia_congenita: null ,
    outros_procedimentos_cardiacos: [],
    uso_videotoracoscopia: null ,
    uso_plataforma_robotica: null ,
    uso_afastador_partes_moles: null ,
    especificacoes_afastador_partes_moles: null ,
    uso_fixacao_rigida: null ,
    sitio_fixacao_rigida: [],
    especificacoes_protese_fixacao_rigida: null ,
    pericardiotomia_posterior_esquerda: null ,
    drenagem_pericardica: [],
    drenagem_pleural: [],
    tipo_dreno_pleural_utilizado: [],
    plataforma_robotica_utilizada: null ,
    revascularizacao_com_cec: null ,
    numero_coronarias_acometidas: null ,
    numero_coronarias_abordadas: null ,
    numero_enxertos_utilizados: null ,
    uso_atie: null ,
    metodo_disseccao_atie: null ,
    material_utilizado_atie: [],
    uso_atid: null ,
    metodo_disseccao_atid: null ,
    material_utilizado_atid: [],
    uso_arteria_radial: null ,
    uso_arteria_gastroepiploica: null ,
    uso_arteria_epigastrica_inferior: null ,
    uso_veia_safena_magna: null ,
    uso_estabilizador_cardiaco: null ,
    uso_posicionador_cardiaco: null ,
    material_anastomose_coronariana: [],
    marca_material_mini: [],
    angioplastia_programada_cirurgia_hibrida: null ,
    abordagem_valva_aortica: null ,
    abordagem_valva_mitral: null ,
    abordagem_valva_pulmonar: null ,
    abordagem_valva_tricuspide: null ,
    segmentos_aorta_abordados: [],
    uso_tubo_sintetico: null ,
    especificacoes_material_aorta: null ,
    programacao_procedimento_hibrido: null ,
    cardiopatia_congenita_abordada: [], // Array para múltiplas respostas
    uso_pericardio: null ,
    retirada_endoscopica_radial: null ,
    uso_safena_no_touch: null ,
    retirada_endoscopica_safena: null ,
    uso_enxertos_compostos: null ,
    estabilizador_utilizado: null ,
    posicionador_utilizado: null ,
    plastia_valvar_aortica: null ,
    troca_valvar_aortica: null ,
    via_acesso_valva_mitral: null ,
    plastia_valvar_mitral: null ,
    troca_valvar_mitral: null ,
    fechamento_auriculeta_esquerda: null ,
    plastia_valvar_pulmonar: null ,
    troca_valvar_pulmonar: null ,
    plastia_valvar_tricuspide: null ,
    troca_valvar_tricuspide: null ,
    reimplante_coronarias: null ,
    preservacao_valva_aortica_nativa: null ,
    tamanho_tubo_sintetico: 0,
    uso_tubo_valvado: null ,
    uso_tecnica_y: null ,
    uso_anastomoses_sequenciais: null ,
    tecnica_plastia_valvar_aortica: null ,
    gradiente_medio_valvar_aortico_pos_cec: 0,
    insuficiencia_aortica_pos_cec: null ,
    protese_valvar_aortica: null ,
    tamanho_protese_valvar_aortica: 0,
    protese_liberacao_rapida_aortica: null ,
    especificacoes_protese_aortica: null ,
    leak_paravalvar_aortico: null ,
    comissurotomia_mitral: null ,
    uso_neocorda: null ,
    uso_anel_mitral: null ,
    uso_anel_tricuspide: null ,
    resseccao_folheto_mitral: null ,
    anuloplastia_posterior_mitral: null ,
    gradiente_medio_valva_mitral_pos_cec: 0,
    insuficiencia_mitral_pos_cec: null ,
    protese_valvar_mitral: null ,
    tamanho_protese_valvar_mitral: 0,
    protese_liberacao_rapida_mitral: null ,
    especificacoes_protese_mitral: null ,
    leak_paravalvar_mitral: null ,
    tecnica_plastia_valvar_pulmonar: null ,
    gradiente_medio_valvar_pulmonar_pos_cec: 0,
    insuficiencia_pulmonar_pos_cec: null ,
    protese_valvar_pulmonar: null ,
    tamanho_protese_valvar_pulmonar: 0,
    protese_liberacao_rapida_pulmonar: null ,
    uso_protese_pulmonar_endovascular: null ,
    protese_pulmonar_tratamento_anticalcificante: null ,
    especificacoes_protese_pulmonar: null ,
    leak_paravalvar_pulmonar: null ,
    tecnica_plastia_valvar_tricuspide: [],
    gradiente_medio_valvar_tricuspide_pos_cec: 0,
    insuficiencia_valvar_tricuspide_pos_cec: null ,
    protese_valvar_tricuspide: null ,
    tamanho_protese_valvar_tricuspide: 0,
    protese_liberacao_rapida_tricuspide: null ,
    uso_protese_tricuspide_endovascular: null ,
    protese_tricuspide_tratamento_anticalcificante: null ,
    especificacoes_protese_tricuspide: null ,
    leak_paravalvar_tricuspide: null ,
    tipo_valva_tubo_valvado: null ,
    uso_protese_aortica_endovascular: null ,
    protese_aortica_tratamento_anticalcificante: null ,
    especificacoes_neocorda: null ,
    especificacoes_anel_mitral: null ,
    uso_protese_mitral_endovascular: null ,
    protese_mitral_tratamento_anticalcificante: null ,
    especificacoes_anel_tricuspide: null 
  });

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (id) {
      fetch(`${process.env.REACT_APP_API_URL}/cirurgia/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            const yesNoFields = [
                "revascularizacao",
                "abordagem_valvar",
                "abordagem_aorta",
                "correcao_cardiopatia_congenita",
                "uso_videotoracoscopia",
                "uso_plataforma_robotica",
                "uso_afastador_partes_moles",
                "uso_fixacao_rigida",
                "pericardiotomia_posterior_esquerda",
                "revascularizacao_com_cec",
                "uso_atie",
                "uso_atid",
                "uso_arteria_radial",
                "uso_arteria_gastroepiploica",
                "uso_arteria_epigastrica_inferior",
                "uso_veia_safena_magna",
                "uso_estabilizador_cardiaco",
                "uso_posicionador_cardiaco",
                "angioplastia_programada_cirurgia_hibrida",
                "abordagem_valva_aortica",
                "abordagem_valva_mitral",
                "abordagem_valva_pulmonar",
                "abordagem_valva_tricuspide",
                "uso_tubo_sintetico",
                "uso_pericardio",
                "retirada_endoscopica_radial",
                "uso_safena_no_touch",
                "retirada_endoscopica_safena",
                "uso_enxertos_compostos",
                "plastia_valvar_aortica",
                "troca_valvar_aortica",
                "plastia_valvar_mitral",
                "troca_valvar_mitral",
                "fechamento_auriculeta_esquerda",
                "plastia_valvar_pulmonar",
                "troca_valvar_pulmonar",
                "plastia_valvar_tricuspide",
                "troca_valvar_tricuspide",
                "reimplante_coronarias",
                "preservacao_valva_aortica_nativa",
                "uso_tubo_valvado",
                "uso_tecnica_y",
                "uso_anastomoses_sequenciais",
                "comissurotomia_mitral",
                "uso_neocorda",
                "uso_anel_mitral",
                "resseccao_folheto_mitral",
                "anuloplastia_posterior_mitral",
                "uso_protese_mitral_endovascular",
                "protese_mitral_tratamento_anticalcificante",
                "uso_protese_pulmonar_endovascular",
                "protese_pulmonar_tratamento_anticalcificante",
                "uso_protese_tricuspide_endovascular",
                "protese_tricuspide_tratamento_anticalcificante",
                "uso_protese_aortica_endovascular",
                "protese_aortica_tratamento_anticalcificante",
                "uso_afastador_partes_moles",
                "uso_fixacao_rigida",
                "fechamento_auriculeta_esquerda",
                "uso_anel_carpentier",
                "uso_estabilizador_cardiaco_paracoronariano",
                "programacao_procedimento_hibrido"
            ];

            const convertedData = convertYesNoFieldsToString(data.data, yesNoFields);
            setFormData(convertedData);

          } else {
            notify({
              type: "error",
              message: data.error || "Erro ao buscar os dados",
            });
          }
        })
        .catch(() => {
          notify({
            type: "error",
            message: "Erro ao buscar os dados",
          });
        });
    }
  }, [id, token, notify]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  // Função para lidar com checkbox
  const handleCheckboxChange = (e, field) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      const updatedValues = checked
        ? [...prev[field], value] // Adiciona se estiver checado
        : prev[field].filter((v) => v !== value); // Remove se desmarcado
      return { ...prev, [field]: updatedValues };
    });
  };
  
  const requiredFields = [
    "revascularizacao",
    "abordagem_valvar",
    "abordagem_aorta",
    "correcao_cardiopatia_congenita",
    "outros_procedimentos_cardiacos",
    "uso_videotoracoscopia",
    "uso_plataforma_robotica"
];

  const apiUrl = id
  ? `${process.env.REACT_APP_API_URL}/cirurgia/update/${id}`
  : `${process.env.REACT_APP_API_URL}/cirurgia/add`;

  const handleSubmit = () => {
    const method = id ? "PUT" : "POST";
    fetch(apiUrl, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          notify({
            type: "success",
            message: id ? "Cirurgia atualizada com sucesso!" : "Cirurgia adicionada com sucesso!",
          });
        } else {
          response.json().then((data) => {
            notify({
              type: "error",
              message: `Erro: ${data.error}`,
            });
          });
        }
      })
      .catch(() => {
        notify({
          type: "error",
          message: "Erro ao enviar os dados",
        });
      });
  };

  const confirmSave = handleConfirmSave(formData, requiredFields, validateFields, GetTranslation, notify, handleSubmit);
  const handleBack = handleNavigateBack(navigate, id);

  return (
    <div className="card p-3">
      <ConfirmDialog />
      <h4>{id ? GetTranslation("Edit_Cirurgia") : GetTranslation("Add_Cirurgia")}</h4>
      <form className="row g-3">
            {/* 1 - Revascularização */}
            {renderYesNoField(
                formData,
                handleChange,
                "revascularizacao",
                "Revascularização",
                GetTranslation,
            )}

            {/* 2 - Abordagem Valvar */}
            {renderYesNoField(
                formData,
                handleChange,
                "abordagem_valvar",
                "Abordagem Valvar",
                GetTranslation,
            )}

            {/* 3 - Abordagem da Aorta */}
            {renderYesNoField(
                formData,
                handleChange,
                "abordagem_aorta",
                "Abordagem da Aorta",
                GetTranslation,
            )}

            {/* 4 - Correção de Cardiopatia Congênita */}
            {renderYesNoField(
                formData,
                handleChange,
                "correcao_cardiopatia_congenita",
                "Correção de Cardiopatia Congênita",
                GetTranslation,
            )}

            {/* 5 - Outros Procedimentos Cardíacos */}
            {renderCheckboxGroup(
                formData,
                handleCheckboxChange,
                "outros_procedimentos_cardiacos",
                "Outros Procedimentos Cardíacos",
                [
                    "Não",
                    "Ressecção de Tumor intracardíaco",
                    "Transplante Cardíaco",
                    "Implante de eletrodo epicárdico",
                    "Janela pleuropericárdica",
                    "Pericardiectomia",
                    "Cox Maze",
                    "Fechamento de auriculeta"
                ],
                GetTranslation,
            )}

            {/* 6 - Uso de Videotoracoscopia */}
            {renderYesNoField(
                formData,
                handleChange,
                "uso_videotoracoscopia",
                "Uso de Videotoracoscopia",
                GetTranslation,
            )}

            {/* 7 - Uso de Plataforma Robótica */}
            {renderYesNoField(
                formData,
                handleChange,
                "uso_plataforma_robotica",
                "Uso de Plataforma Robótica",
                GetTranslation,
            )}

            {/* 8- Uso de Afastador de Partes Moles */}
            {renderYesNoField(
                formData,
                handleChange,
                "uso_afastador_partes_moles",
                "Uso de Afastador de Partes Moles",
                GetTranslation
            )}

            {/* 9 - Especificações do Afastador de Partes Moles */}
            {formData.uso_afastador_partes_moles === "1" && 
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_afastador_partes_moles",
                    "Especificações do Afastador de Partes Moles",
                    GetTranslation
            )}

            {/* 10 - Uso de Fixação Rígida */}
            {renderYesNoField(
                formData,
                handleChange,
                "uso_fixacao_rigida",
                "Uso de Fixação Rígida",
                GetTranslation
            )}

            {/* 11 - Sítio da Fixação Rígida */}
            {formData.uso_fixacao_rigida === "1" && 
                renderCheckboxGroup(
                    formData,
                    handleCheckboxChange,
                    "sitio_fixacao_rigida",
                    "Sítio da Fixação Rígida",
                    ["Esterno", "Costela"],
                    GetTranslation
            )}

            {/* 12 - Especificações da Prótese de Fixação Rígida */}
            {formData.uso_fixacao_rigida === "1" && 
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_protese_fixacao_rigida",
                    "Especificações da Prótese de Fixação Rígida",
                    GetTranslation
            )}

            {/* 13 - Pericardiotomia Posterior Esquerda */}
            {renderYesNoField(
                formData,
                handleChange,
                "pericardiotomia_posterior_esquerda",
                "Pericardiotomia Posterior Esquerda",
                GetTranslation
            )}

            {/* 14 - Drenagem Pericárdica */}
            {renderCheckboxGroup(
                formData,
                handleCheckboxChange,
                "drenagem_pericardica",
                "Drenagem Pericárdica",
                ["Não", "Tubular", "Blake", "JP"],
                GetTranslation
            )}

            {/* 15 - Drenagem Pleural */}
            {renderCheckboxGroup(
                formData,
                handleCheckboxChange,
                "drenagem_pleural",
                "Drenagem Pleural",
                ["Não", "Direito", "Esquerdo", "Bilateral"],
                GetTranslation
            )}

            {/* 16 - Tipo de Dreno Pleural Utilizado */}
            {formData.drenagem_pleural !== "Não" && 
                renderCheckboxGroup(
                    formData,
                    handleCheckboxChange,
                    "tipo_dreno_pleural_utilizado",
                    "Tipo de Dreno Pleural Utilizado",
                    ["Tubular", "Pigtail", "Blake", "JP"],
                    GetTranslation
            )}

            {/* 17 - Plataforma Robótica Utilizada */}
            {formData.uso_plataforma_robotica === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "plataforma_robotica_utilizada",
                    "Plataforma Robótica Utilizada",
                    ["Strattner Intuitive", "Hugo"],
                    GetTranslation
            )}

            {/* 18 - Revascularização com CEC */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "revascularizacao_com_cec",
                    "Revascularização com CEC",
                    GetTranslation
            )}

            {/* 19 - Número de Coronárias Acometidas */}
            {formData.revascularizacao === "1" && 
                renderRangeField(
                    formData,
                    setFormData,
                    "numero_coronarias_acometidas",
                    "Número de Coronárias Acometidas",
                    1,
                    10,
                    1,
                    GetTranslation,
                    "(qualquer lesão de pelo menos 50%)"
            )}

            {/* 20 - Número de Coronárias Abordadas */}
            {formData.revascularizacao === "1" && 
                renderRangeField(
                    formData,
                    setFormData,
                    "numero_coronarias_abordadas",
                    "Número de Coronárias Abordadas",
                    1,
                    10,
                    1,
                    GetTranslation
            )}

            {/* 21 - Número de Enxertos Utilizados */}
            {formData.revascularizacao === "1" && 
                renderRangeField(
                    formData,
                    setFormData,
                    "numero_enxertos_utilizados",
                    "Número de Enxertos Utilizados",
                    1,
                    10,
                    1,
                    GetTranslation
            )}

            {/* 22 - Uso de ATIE */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_atie",
                    "Uso de ATIE",
                    GetTranslation
            )}

            {/* 23 - Método de Dissecção da ATIE */}
            {formData.uso_atie === "1" && formData.revascularizacao === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "metodo_disseccao_atie",
                    "Método de Dissecção da ATIE",
                    ["Visão direta", "Vídeo-assistida", "Endoscópica", "Robótica por esternotomia", "Robótica por toracotomia lateral", "Robótica endoscópica"],
                    GetTranslation
            )}

            {/* 24 - Material Utilizado na Dissecção da ATIE */}
            {formData.uso_atie === "1" && formData.revascularizacao === "1" && 
                renderCheckboxGroup(
                    formData,
                    handleCheckboxChange,
                    "material_utilizado_atie",
                    "Material Utilizado na Dissecção da ATIE",
                    [
                        "Pinça de coronária convencional",
                        "Pinça de mini",
                        "Tesoura de Potts/Dietrich convencional",
                        "Tesoura de mini",
                        "Bisturi elétrico monopolar convencional",
                        "Bisturi elétrico com extensor de lâmina",
                        "Bisturi harmônico",
                        "Bisturi elétrico bipolar",
                        "Bisturi de vídeo Hook",
                        "Bisturi Ligasure",
                        "Plataforma robótica"
                    ],
                    GetTranslation
            )}

            {/* 25 - Uso de ATID */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_atid",
                    "Uso de ATID",
                    GetTranslation
            )}

            {/* 26 - Método de Dissecção da ATID */}
            {formData.uso_atid === "1" && formData.revascularizacao === "1" &&   
                renderSelectField(
                    formData,
                    handleChange,
                    "metodo_disseccao_atid",
                    "Método de Dissecção da ATID",
                    ["Visão direta", "Vídeo-assistida", "Endoscópica", "Robótica por esternotomia", "Robótica por toracotomia lateral", "Robótica endoscópica"],
                    GetTranslation
            )}

            {/* 27 - Material Utilizado na Dissecção da ATID */}
            {formData.uso_atid === "1" && formData.revascularizacao === "1" &&  
                renderCheckboxGroup(
                    formData,
                    handleCheckboxChange,
                    "material_utilizado_atid",
                    "Material Utilizado na Dissecção da ATID",
                    [
                        "Pinça de coronária convencional",
                        "Pinça de mini",
                        "Tesoura de Potts/Dietrich convencional",
                        "Tesoura de mini",
                        "Bisturi elétrico monopolar convencional",
                        "Bisturi elétrico com extensor de lâmina",
                        "Bisturi harmônico",
                        "Bisturi elétrico bipolar",
                        "Bisturi de vídeo Hook",
                        "Bisturi Ligasure",
                        "Plataforma robótica"
                    ],
                    GetTranslation
            )}

            {/* 28 - Uso de A. Radial */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_arteria_radial",
                    "Uso de A. Radial",
                    GetTranslation
            )}

            {/* 29 -  Uso de A. Gastroepiploica */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_arteria_gastroepiploica",
                    "Uso de A. Gastroepiploica",
                    GetTranslation
            )}

            {/* 30 -  Uso de A. Epigástrica Inferior */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_arteria_epigastrica_inferior",
                    "Uso de A. Epigástrica Inferior",
                    GetTranslation
            )}

            {/* 31 -  Uso de V. Safena Magna */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_veia_safena_magna",
                    "Uso de V. Safena Magna",
                    GetTranslation
            )}

            {/* 32 -  Uso de Estabilizador Cardíaco */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_estabilizador_cardiaco",
                    "Uso de Estabilizador Cardíaco",
                    GetTranslation
            )}

            {/* 33 -  Uso de Posicionador Cardíaco */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_posicionador_cardiaco",
                    "Uso de Posicionador Cardíaco",
                    GetTranslation
            )}

            {/* 34 -  Material Utilizado na Anastomose Coronariana */}
            {formData.revascularizacao === "1" && 
                renderCheckboxGroup(
                    formData,
                    handleCheckboxChange,
                    "material_anastomose_coronariana",
                    "Material Utilizado na Anastomose Coronariana",
                    [
                        "Pinça de coronária convencional",
                        "Pinça de mini",
                        "Castroviejo Mini",
                        "Castroviejo convencional",
                        "Tesoura de Potts/Dietrich convencional",
                        "Tesoura de mini",
                        "Pinça robótica",
                        "Porta-agulhas robótica",
                        "Tesoura robótica"
                    ],
                    GetTranslation
            )}

            {/* 35 -  Marca do Material de Mini Utilizado */}
            {formData.revascularizacao === "1" && 
                renderCheckboxGroup(
                    formData,
                    handleCheckboxChange,
                    "marca_material_mini",
                    "Marca do Material de Mini Utilizado",
                    ["Não utilizado", "Wexler", "Delacroa", "Scanlan"],
                    GetTranslation
            )}

            {/* 36 -  Angioplastia Programada (Cirurgia Híbrida) */}
            {formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "angioplastia_programada_cirurgia_hibrida",
                    "Angioplastia Programada (Cirurgia Híbrida)",
                    GetTranslation
            )}

            {/* 37 - Abordagem da Valva Aórtica */}
            {formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "abordagem_valva_aortica",
                    "Abordagem da Valva Aórtica",
                    GetTranslation
            )}

            {/* 38 - Abordagem da Valva Mitral */}
            {formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "abordagem_valva_mitral",
                    "Abordagem da Valva Mitral",
                    GetTranslation
            )}

            {/* 39 - Abordagem da Valva Pulmonar */}
            {formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "abordagem_valva_pulmonar",
                    "Abordagem da Valva Pulmonar",
                    GetTranslation
            )}

            {/* 40 - Abordagem da Valva Tricúspide */}
            {formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "abordagem_valva_tricuspide",
                    "Abordagem da Valva Tricúspide",
                    GetTranslation
            )}

            {/* 41 - Segmentos da Aorta Abordados */}
            {formData.abordagem_aorta === "1" && 
                renderCheckboxGroup(
                    formData,
                    handleCheckboxChange,
                    "segmentos_aorta_abordados",
                    "Segmentos da Aorta Abordados",
                    ["Raiz", "Aorta Ascendente", "Outros"],
                    GetTranslation
            )}

            {/* 42 - Uso de Tubo Sintético */}
            {formData.abordagem_aorta === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_tubo_sintetico",
                    "Uso de Tubo Sintético",
                    GetTranslation
            )}

            {/* 43 - Especificações do Material Utilizado na Aorta */}
            {formData.uso_tubo_sintetico === "1" && formData.abordagem_aorta === "1" && 
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_material_aorta",
                    "Especificações do Material Utilizado na Aorta",
                    GetTranslation
            )}

            {/* 44 - Programação de Procedimento Híbrido */}
            {/** DUPLICIDADE */}

            {/* 45 - Cardiopatia Congênita Abordada */}
            {formData.correcao_cardiopatia_congenita === "1" && 
                renderCheckboxGroup(
                    formData,
                    handleCheckboxChange,
                    "cardiopatia_congenita_abordada",
                    "Cardiopatia Congênita Abordada",
                    [
                        "Atriosseptoplastia",
                        "Ventriculosseptoplastia",
                        "Correção de DSAV total",
                        "Correção de DSAV parcial",
                        "Fechamento de FOP",
                        "Fechamento de Canal Arterial Patente",
                        "Bandagem de Artérias Pulmonares",
                        "Outras"
                    ],
                    GetTranslation
            )}

            {/* 46 - Uso de Pericárdio */}
            {formData.correcao_cardiopatia_congenita === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_pericardio",
                    "Uso de Pericárdio",
                    GetTranslation
            )}

            {/* 47 - Programação de Procedimento Híbrido */}
            {(formData.correcao_cardiopatia_congenita === "1" || formData.correcao_cardiopatia_congenita === "1") && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "programacao_procedimento_hibrido",
                    "Programação de Procedimento Híbrido",
                    GetTranslation
            )}

            {/* 48 - Retirada Endoscópica da Radial */}
            {formData.uso_arteria_radial === "1" && formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "retirada_endoscopica_radial",
                    "Retirada Endoscópica da Radial",
                    GetTranslation
            )}

            {/* 49 - Uso da Técnica Safena No-Touch */}
            {formData.uso_veia_safena_magna === "1" && formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_safena_no_touch",
                    "Uso da Técnica Safena No-Touch",
                    GetTranslation
            )}

            {/* 50 - Retirada Endoscópica da Safena */}
            {formData.uso_veia_safena_magna === "1" && formData.revascularizacao === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "retirada_endoscopica_safena",
                    "Retirada Endoscópica da Safena",
                    GetTranslation
            )}

            {/* 51 - Uso de Enxertos Compostos */}
            {formData.numero_coronarias_abordadas > 1 && formData.revascularizacao === "1" &&  
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_enxertos_compostos",
                    "Uso de Enxertos Compostos",
                    GetTranslation
            )}

            {/* 52 - Estabilizador Utilizado */}
            {formData.uso_estabilizador_cardiaco === "1" && formData.revascularizacao === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "estabilizador_utilizado",
                    "Estabilizador Utilizado",
                    ["Medtronic Octopus", "Medtronic Octopus Nuvo", "Getinge"],
                    GetTranslation
            )}

            {/* 53 - Posicionador Utilizado */}
            {formData.uso_posicionador_cardiaco === "1" && formData.revascularizacao === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "posicionador_utilizado",
                    "Posicionador Utilizado",
                    ["Medtronic Starfish", "Getinge Acrobat"],
                    GetTranslation
            )}

            {/* 54 -  Plastia Valvar Aórtica */}
            {formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "plastia_valvar_aortica",
                    "Plastia Valvar Aórtica",
                    GetTranslation
            )}

            {/* 55 -  Troca Valvar Aórtica */}
            {formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "troca_valvar_aortica",
                    "Troca Valvar Aórtica",
                    GetTranslation
            )}

            {/* 56 -  Via de Acesso da Valva Mitral */}
            {formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "via_acesso_valva_mitral",
                    "Via de Acesso da Valva Mitral",
                    ["Atriotomia esquerda", "Transeptal", "Outra"],
                    GetTranslation
            )}

            {/* 57 -  Plastia Valvar Mitral */}
            {formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "plastia_valvar_mitral",
                    "Plastia Valvar Mitral",
                    GetTranslation
            )}

            {/* 58 -  Troca Valvar Mitral */}
            {formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "troca_valvar_mitral",
                    "Troca Valvar Mitral",
                    GetTranslation
            )}

            {/* 59 -  Fechamento de Auriculeta Esquerda */}
            {formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "fechamento_auriculeta_esquerda",
                    "Fechamento de Auriculeta Esquerda",
                    GetTranslation
            )}

            {/* 60 -  Plastia Valvar Pulmonar */}
            {formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderYesNoField(
                    formData,
                    handleChange,
                    "plastia_valvar_pulmonar",
                    "Plastia Valvar Pulmonar",
                    GetTranslation
            )}

            {/* 61 -  Troca Valvar Pulmonar */}
            {formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderYesNoField(
                    formData,
                    handleChange,
                    "troca_valvar_pulmonar",
                    "Troca Valvar Pulmonar",
                    GetTranslation
            )}

            {/* 62 -  Plastia Valvar Tricúspide */}
            {formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "plastia_valvar_tricuspide",
                    "Plastia Valvar Tricúspide",
                    GetTranslation
            )}

            {/* 63 -  Troca Valvar Tricúspide */}
            {formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "troca_valvar_tricuspide",
                    "Troca Valvar Tricúspide",
                    GetTranslation
            )}

            {/* 64 -  Reimplante de Coronárias */}
            {formData.segmentos_aorta_abordados?.includes("Raiz") && formData.abordagem_aorta === "1" &&
                renderYesNoField(
                    formData,
                    handleChange,
                    "reimplante_coronarias",
                    "Reimplante de Coronárias",
                    GetTranslation
            )}

            {/* 65 -  Preservação da Valva Aórtica Nativa */}
            {formData.segmentos_aorta_abordados?.includes("Raiz") && formData.abordagem_aorta === "1" &&
                renderYesNoField(
                    formData,
                    handleChange,
                    "preservacao_valva_aortica_nativa",
                    "Preservação da Valva Aórtica Nativa",
                    GetTranslation
            )}

            {/* 66 -  Tamanho do Tubo Sintético */}
            {formData.uso_tubo_sintetico === "1" && formData.abordagem_aorta === "1" && 
                renderRangeField(
                    formData,
                    setFormData,
                    "tamanho_tubo_sintetico",
                    "Tamanho do Tubo Sintético",
                    0,
                    50,
                    0,
                    GetTranslation,
                    "(mm)"
            )}

            {/* 67 -  Uso de Tubo Valvado */}
            {formData.uso_tubo_sintetico === "1" && formData.abordagem_aorta === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_tubo_valvado",
                    "Uso de Tubo Valvado",
                    GetTranslation
            )}

            {/* 68 -  Uso de Técnica em Y */}
            {formData.uso_enxertos_compostos === "1" && formData.numero_coronarias_abordadas > 1 && formData.revascularizacao === "1" &&  
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_tecnica_y",
                    "Uso de Técnica em Y",
                    GetTranslation
            )}

            {/* 69 -  Uso de Anastomoses Sequenciais */}
            {formData.uso_enxertos_compostos === "1" && formData.numero_coronarias_abordadas > 1 && formData.revascularizacao === "1" &&  
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_anastomoses_sequenciais",
                    "Uso de Anastomoses Sequenciais",
                    GetTranslation
            )}

            {/* 70 - Técnica de Plastia Valvar Aórtica */}
            {formData.plastia_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" &&
                renderSelectField(
                    formData,
                    handleChange,
                    "tecnica_plastia_valvar_aortica",
                    "Técnica de Plastia Valvar Aórtica",
                    ["Plicatura de válvulas", "Suspensão de postes comissurais", "Comissurotomia", "Ampliação de folheto"],
                    GetTranslation
            )}

            {/* 71 - Gradiente Médio Valvar Aórtico Pós-CEC */}
            {formData.plastia_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" &&
                renderRangeField(
                    formData,
                    setFormData,
                    "gradiente_medio_valvar_aortico_pos_cec",
                    "Gradiente Médio Valvar Aórtico Pós-CEC",
                    0,
                    200,
                    0,
                    GetTranslation,
                    "(mmHg)"
            )}

            {/* 72 - Insuficiência Aórtica Pós-CEC */}
            {formData.plastia_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" &&
                renderSelectField(
                    formData,
                    handleChange,
                    "insuficiencia_aortica_pos_cec",
                    "Insuficiência Aórtica Pós-CEC",
                    ["Sem insuficiência", "Mínima", "Discreta", "Moderada", "Importante", "Não aferida"],
                    GetTranslation
            )}

            {/* 73 - Prótese Valvar Aórtica */}
            {formData.troca_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "protese_valvar_aortica",
                    "Prótese Valvar Aórtica",
                    ["Prótese biológica", "Prótese mecânica"],
                    GetTranslation
            )}

            {/* 74 - Tamanho da Prótese Valvar Aórtica */}
            {formData.troca_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && 
                renderRangeField(
                    formData,
                    setFormData,
                    "tamanho_protese_valvar_aortica",
                    "Tamanho da Prótese Valvar Aórtica (mm)",
                    0,
                    40,
                    0,
                    GetTranslation
            )}

            {/* 75 - Prótese de Liberação Rápida Aórtica */}
            {formData.troca_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "protese_liberacao_rapida_aortica",
                    "Prótese de Liberação Rápida Aórtica",
                    GetTranslation
            )}

            {/* 76 - Especificações da Prótese Aórtica */}
            {formData.troca_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && 
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_protese_aortica",
                    "Especificações da Prótese Aórtica",
                    GetTranslation
            )}

            {/* 77 - Leak Paravalvar Aórtico */}
            {formData.troca_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "leak_paravalvar_aortico",
                    "Leak Paravalvar Aórtico",
                    ["Sem leak", "Mínimo", "Discreto", "Moderado", "Importante", "Não aferido"],
                    GetTranslation
            )}

            {/* 78 - Comissurotomia Mitral */}
            {formData.plastia_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "comissurotomia_mitral",
                    "Comissurotomia Mitral",
                    GetTranslation
            )}

            {/* 79 - Uso de Neocorda */}
            {formData.plastia_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_neocorda",
                    "Uso de Neocorda",
                    GetTranslation
            )}

            {/* 80 - Uso de Anel Mitral */}
            {formData.plastia_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_anel_mitral",
                    "Uso de Anel Mitral",
                    GetTranslation
            )}

            {/* 81 - Ressecção de Folheto Mitral */}
            {formData.plastia_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "resseccao_folheto_mitral",
                    "Ressecção de Folheto Mitral",
                    GetTranslation
            )}

            {/* 82 - Anuloplastia Posterior Mitral */}
            {formData.plastia_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "anuloplastia_posterior_mitral",
                    "Anuloplastia Posterior Mitral",
                    GetTranslation
            )}

            {/* 83 - Gradiente Médio Valva Mitral Pós-CEC */}
            {formData.plastia_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderRangeField(
                    formData,
                    setFormData,
                    "gradiente_medio_valva_mitral_pos_cec",
                    "Gradiente Médio Valva Mitral Pós-CEC",
                    0,
                    50,
                    0,
                    GetTranslation,
                    "(mmHg)"
            )}

            {/* 84 - Insuficiência Mitral Pós-CEC */}
            {formData.plastia_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "insuficiencia_mitral_pos_cec",
                    "Insuficiência Mitral Pós-CEC",
                    ["Sem insuficiência", "Mínima", "Discreta", "Moderada", "Importante", "Não aferida"],
                    GetTranslation
            )}

            {/* 85 - Prótese Valvar Mitral */}
            {formData.troca_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "protese_valvar_mitral",
                    "Prótese Valvar Mitral",
                    ["Prótese biológica", "Prótese mecânica"],
                    GetTranslation
            )}

            {/* 86 - Tamanho da Prótese Valvar Mitral */}
            {formData.troca_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderRangeField(
                    formData,
                    setFormData,
                    "tamanho_protese_valvar_mitral",
                    "Tamanho da Prótese Valvar Mitral",
                    0,
                    50,
                    0,
                    GetTranslation,
                    "(mm)"
            )}

            {/* 87 - Prótese de Liberação Rápida Mitral */}
            {formData.troca_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "protese_liberacao_rapida_mitral",
                    "Prótese de Liberação Rápida Mitral",
                    GetTranslation
            )}

            {/* 88 - Especificações da Prótese Mitral */}
            {formData.troca_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_protese_mitral",
                    "Especificações da Prótese Mitral",
                    GetTranslation
            )}

            {/* 89 - Leak Paravalvar Mitral */}
            {formData.troca_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "leak_paravalvar_mitral",
                    "Leak Paravalvar Mitral",
                    ["Sem leak", "Mínimo", "Discreto", "Moderado", "Importante", "Não aferido"],
                    GetTranslation
            )}

            {/* 89 - Técnica de Plastia Valvar Pulmonar */}
            {formData.plastia_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderSelectField(
                    formData,
                    handleChange,
                    "tecnica_plastia_valvar_pulmonar",
                    "Técnica de Plastia Valvar Pulmonar",
                    ["Comissurotomia", "Suspensão de postes comissurais", "Plicatura valvar", "Ampliação de folheto", "Anuloplastia"],
                    GetTranslation
            )}

            {/* 90 - Gradiente Médio Valvar Pulmonar Pós-CEC */}
            {formData.plastia_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderRangeField(
                    formData,
                    setFormData,
                    "gradiente_medio_valvar_pulmonar_pos_cec",
                    "Gradiente Médio Valvar Pulmonar Pós-CEC",
                    0,
                    100,
                    0,
                    GetTranslation,
                    "(mmHg)"
            )}

            {/* 91 - Insuficiência Pulmonar Pós-CEC */}
            {formData.plastia_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderSelectField(
                    formData,
                    handleChange,
                    "insuficiencia_pulmonar_pos_cec",
                    "Insuficiência Pulmonar Pós-CEC",
                    ["Sem insuficiência", "Mínima", "Discreta", "Moderada", "Importante", "Não aferida"],
                    GetTranslation
            )}

            {/* 92 - Prótese Valvar Pulmonar */}
            {formData.troca_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderSelectField(
                    formData,
                    handleChange,
                    "protese_valvar_pulmonar",
                    "Prótese Valvar Pulmonar",
                    ["Prótese biológica", "Prótese mecânica", "Homoenxerto"],
                    GetTranslation
            )}

            {/* 93 - Tamanho da Prótese Valvar Pulmonar */}
            {formData.troca_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderRangeField(
                    formData,
                    setFormData,
                    "tamanho_protese_valvar_pulmonar",
                    "Tamanho da Prótese Valvar Pulmonar",
                    0,
                    50,
                    0,
                    GetTranslation,
                    "(mm)"
            )}

            {/* 94 - Prótese de Liberação Rápida Pulmonar */}
            {formData.troca_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderYesNoField(
                    formData,
                    handleChange,
                    "protese_liberacao_rapida_pulmonar",
                    "Prótese de Liberação Rápida Pulmonar",
                    GetTranslation
            )}

            {/* 95 - Uso de Prótese Pulmonar Endovascular */}
            {formData.troca_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_protese_pulmonar_endovascular",
                    "Uso de Prótese Pulmonar Endovascular",
                    GetTranslation
            )}

            {/* 96 - Prótese Pulmonar com Tratamento Anticalcificante */}
            {formData.troca_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderYesNoField(
                    formData,
                    handleChange,
                    "protese_pulmonar_tratamento_anticalcificante",
                    "Prótese Pulmonar com Tratamento Anticalcificante",
                    GetTranslation
            )}

            {/* 97 - Especificações da Prótese Pulmonar */}
            {formData.troca_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_protese_pulmonar",
                    "Especificações da Prótese Pulmonar",
                    GetTranslation
            )}

            {/* 98 - Leak Paravalvar Pulmonar */}
            {formData.troca_valvar_pulmonar === "1" && formData.abordagem_valva_pulmonar === "1" && formData.abordagem_valvar === "1" &&
                renderSelectField(
                    formData,
                    handleChange,
                    "leak_paravalvar_pulmonar",
                    "Leak Paravalvar Pulmonar",
                    ["Sem leak", "Mínimo", "Discreto", "Moderado", "Importante", "Não aferido"],
                    GetTranslation
            )}

            {/* 99 -  Técnica de Plastia Valvar Tricúspide */}
            {formData.plastia_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" &&   
                renderCheckboxGroup(
                    formData,
                    handleCheckboxChange,
                    "tecnica_plastia_valvar_tricuspide",
                    "Técnica de Plastia Valvar Tricúspide",
                    [
                        "Anuloplastia a DeVega",
                        "Comissurotomia",
                        "Implante de neocorda",
                        "Ampliação de folheto",
                        "Plicatura de folheto",
                        "Desinserção e reinserção tricúspide",
                        "Papilarotomia",
                        "Encurtamento de cordas tendíneas",
                        "Bicuspidização"
                    ],
                    GetTranslation
            )}

            {/* 100 -  Gradiente Médio Valvar Tricúspide Pós-CEC */}
            {formData.plastia_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" &&   
                renderRangeField(
                    formData,
                    setFormData,
                    "gradiente_medio_valvar_tricuspide_pos_cec",
                    "Gradiente Médio Valvar Tricúspide Pós-CEC (mmHg)",
                    0,
                    50,
                    0,
                    GetTranslation
            )}

            {/* 101 -  Insuficiência Valvar Tricúspide Pós-CEC */}
            {formData.plastia_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" &&   
                renderSelectField(
                    formData,
                    handleChange,
                    "insuficiencia_valvar_tricuspide_pos_cec",
                    "Insuficiência Valvar Tricúspide Pós-CEC",
                    [
                        "Sem insuficiência",
                        "Mínima",
                        "Discreta",
                        "Moderada",
                        "Importante",
                        "Massiva",
                        "Torrencial",
                        "Não aferida"
                    ],
                    GetTranslation
            )}

            {/* 102 -  Prótese Valvar Tricúspide */}
            {formData.troca_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "protese_valvar_tricuspide",
                    "Prótese Valvar Tricúspide",
                    ["Prótese biológica", "Prótese mecânica"],
                    GetTranslation
            )}

            {/* 103 -  Tamanho da Prótese Valvar Tricúspide */}
            {formData.troca_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderRangeField(
                    formData,
                    setFormData,
                    "tamanho_protese_valvar_tricuspide",
                    "Tamanho da Prótese Valvar Tricúspide (mm)",
                    0,
                    50,
                    0,
                    GetTranslation
            )}

            {/* 104 -  Prótese de Liberação Rápida Tricúspide */}
            {formData.troca_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "protese_liberacao_rapida_tricuspide",
                    "Prótese de Liberação Rápida Tricúspide",
                    GetTranslation
            )}

            {/* 105 -  Uso de Prótese Tricúspide Endovascular */}
            {formData.troca_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_protese_tricuspide_endovascular",
                    "Uso de Prótese Tricúspide Endovascular",
                    GetTranslation
            )}

            {/* 106 -  Prótese Tricúspide com Tratamento Anticalcificante */}
            {formData.troca_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "protese_tricuspide_tratamento_anticalcificante",
                    "Prótese Tricúspide com Tratamento Anticalcificante",
                    GetTranslation
            )}

            {/* 107 - Especificações da Prótese Tricúspide */}
            {formData.troca_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_protese_tricuspide",
                    "Especificações da Prótese Tricúspide",
                    GetTranslation
            )}

            {/* 108 - Leak Paravalvar Tricúspide */}
            {formData.troca_valvar_tricuspide === "1" && formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "leak_paravalvar_tricuspide",
                    "Leak Paravalvar Tricúspide",
                    [
                        "Sem leak",
                        "Mínimo",
                        "Discreto",
                        "Moderado",
                        "Importante",
                        "Não aferido"
                    ],
                    GetTranslation
            )}

            {/* 119 - Uso de Anel Tricuspide */}
            {formData.abordagem_valva_tricuspide === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_anel_tricuspide",
                    "Uso de Anel Tricuspide",
                    GetTranslation
            )}

            {/* 118 -  Especificações do Anel Tricúspide */}
            {formData.uso_anel_tricuspide === "1" && 
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_anel_tricuspide",
                    "Especificações do Anel Tricúspide",
                    GetTranslation
            )}

            {/* 109 - Tipo de Valva do Tubo Valvado */}
            {formData.uso_tubo_valvado === "1" && formData.uso_tubo_sintetico === "1" && formData.abordagem_aorta === "1" && 
                renderSelectField(
                    formData,
                    handleChange,
                    "tipo_valva_tubo_valvado",
                    "Tipo de Valva do Tubo Valvado",
                    ["Prótese biológica", "Prótese mecânica"],
                    GetTranslation
            )}

            {/* 111 - Uso de Prótese Aórtica Endovascular */}
            {formData.protese_valvar_aortica === "1" && formData.troca_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_protese_aortica_endovascular",
                    "Uso de Prótese Aórtica Endovascular",
                    GetTranslation
            )}

            {/* 112 - Prótese Aórtica com Tratamento Anticalcificante */}
            {formData.protese_valvar_aortica === "1" && formData.troca_valvar_aortica === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && formData.abordagem_valva_aortica === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "protese_aortica_tratamento_anticalcificante",
                    "Prótese Aórtica com Tratamento Anticalcificante",
                    GetTranslation
            )}

            {/* 113 - Especificações da Neocorda */}
            {formData.uso_neocorda === "1" && formData.plastia_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_neocorda",
                    "Especificações da Neocorda",
                    GetTranslation
            )}

            {/* 114 - Especificações do Anel Mitral */}
            {formData.uso_anel_mitral === "1" && formData.plastia_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" &&
                renderInputTextField(
                    formData,
                    handleChange,
                    "especificacoes_anel_mitral",
                    "Especificações do Anel Mitral",
                    GetTranslation
            )}

            {/* 115 - Uso de Prótese Mitral Endovascular */}
            {formData.protese_valvar_mitral === "1" && formData.troca_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "uso_protese_mitral_endovascular",
                    "Uso de Prótese Mitral Endovascular",
                    GetTranslation
            )}

            {/* 116 - Prótese Mitral com Tratamento Anticalcificante */}
            {formData.protese_valvar_mitral === "1" && formData.troca_valvar_mitral === "1" && formData.abordagem_valva_mitral === "1" && formData.abordagem_valvar === "1" && 
                renderYesNoField(
                    formData,
                    handleChange,
                    "protese_mitral_tratamento_anticalcificante",
                    "Prótese Mitral com Tratamento Anticalcificante",
                    GetTranslation
            )}

            {/* 117 - Especificações da Neocorda */}
            {/** DUPLICIDADE */}

            <div className="col-12 d-flex justify-content-between">
                <Button label={GetTranslation("Voltar")} className="btn btn-secondary" onClick={handleBack} />
                <Button label={id ? GetTranslation("Update") : GetTranslation("Create")} className="btn btn-primary" type="submit" onClick={confirmSave} />
            </div>
        </form>
    </div>
    );
};

export default CirurgiaForm;
